// extracted by mini-css-extract-plugin
export default {"container":"IsaacMessageBar_container__0-rSJ"};